webpackJsonp([104555942287938,35783957827783],{

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = exports.frontmatter = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Article = __webpack_require__(13);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _Block = __webpack_require__(5);
	
	var _Block2 = _interopRequireDefault(_Block);
	
	var _Figure = __webpack_require__(10);
	
	var _Figure2 = _interopRequireDefault(_Figure);
	
	var _pages = __webpack_require__(59);
	
	var _pages2 = _interopRequireDefault(_pages);
	
	var _medical_companion_screenani = __webpack_require__(335);
	
	var _medical_companion_screenani2 = _interopRequireDefault(_medical_companion_screenani);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var frontmatter = exports.frontmatter = {
	  id: 'dsk',
	  isWork: true,
	  title: 'Helping athletes to cope with injuries',
	  subtitle: 'DSK Companion',
	  date: '2017-07-01',
	  path: '/work/dsk-companion',
	  cover: './dsk.png',
	  caption: 'A Google Design Sprint',
	  background: '#EBEEF1',
	  excerpt: 'In the spring semester 2017 at FH Potsdam, I teamed up with Kevin, Isabell and Caspar to work on a project during a class supervised by Marian Gunkel (SAP). The class focused on Lean Startups, Design Sprints and User Testing.',
	  details: [{
	    title: 'Responsibility',
	    description: 'Service Design, Visual Design, Design Sprint'
	  }, {
	    title: 'Context',
	    description: 'University of Applied Sciences Potsdam'
	  }, {
	    title: 'Date',
	    description: 'Summer 2017'
	  }]
	};
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Article2.default,
	    props,
	    _react2.default.createElement(
	      _Block2.default,
	      { mobilePull: true },
	      _react2.default.createElement(
	        'p',
	        null,
	        'In the spring semester 2017 at FH Potsdam, I teamed up with',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: 'http://kevinschiffer.com' },
	          'Kevin'
	        ),
	        ',',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://instagram.com/julezvanderlinden' },
	          'Isabell'
	        ),
	        ' and',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: 'http://casparkirsch.de' },
	          'Caspar'
	        ),
	        ' to work on a project during a class supervised by Marian Gunkel (',
	        _react2.default.createElement(
	          'span',
	          { className: 'caps' },
	          'SAP'
	        ),
	        '). The class focused on Lean Startups, Design Sprints and User Testing.'
	      )
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      { align: 'right' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'We asked ourselves how we can support amateur and professional athletes during uncertain times of injury and recovery. Together, we came up with DSK Companion \u2014 a service design concept for insurance companies.'
	      )
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      { full: true },
	      _react2.default.createElement(_Figure2.default, { sizes: props.data.intro })
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      _Block2.default,
	      { vc: true },
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Persona & Scenario'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'We created a persona as one of our first steps in our Google Design Sprint process: Max, a 23 year old amateur soccer player, who suffered a ligament rupture during a game. He has to undergo surgery and rehabilitation. We documented his journey in a user story.'
	      )
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      { align: 'right' },
	      _react2.default.createElement(_Figure2.default, { sizes: props.data.persona })
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      null,
	      _react2.default.createElement(_Figure2.default, { sizes: props.data.vpc })
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      { vc: true, align: 'right' },
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Value Proposition Canvas'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'After that, we moved on to create a Value Proposition Canvas consisting of \u201CJobs\u201D, \u201CPains\u201D and \u201CGains\u201D of our persona. We then took a vote to see which aspects are most important to us.'
	      )
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      null,
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Ideation'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Going forward from the Value Proposition Canvas, we were able to ask \u201CHow might we...\u201D questions and generate ideas/solutions for those questions.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'We took a vote again and settled on the use of a digital timeline to help athlethes visualize their healing progress.'
	      )
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      { vc: true, align: 'right' },
	      _react2.default.createElement(_Figure2.default, { link: true, sizes: props.data.ideation })
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      _Block2.default,
	      { full: true, pull: true, align: 'center' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Wireframing'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'We created the initial wireframes together on a whiteboard, then moved on to\xA0Figma.'
	      )
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      { full: true },
	      _react2.default.createElement(_Figure2.default, { sizes: props.data.wireframes })
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      null,
	      _react2.default.createElement(_Figure2.default, { sizes: props.data.usertest })
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      { vc: true, align: 'right' },
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Prototyping & User Testing'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'With the digital wireframes on our hands we were able to build a click dummy and hand it to potential users.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'We got the feedback that the timeline was a little confusing and so we added additional affordances to the main screen of our app and got rid of some elements that added unneccesary complexity.'
	      )
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      _Block2.default,
	      { full: true, pull: true, align: 'center' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Screendesign'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Once we were happy with our prototype, we worked out the screendesign of the DSK companion for iOS\xA011.'
	      )
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      { pull: true },
	      _react2.default.createElement(_Figure2.default, {
	        background: true,
	        sizes: props.data.screen1,
	        caption: 'Timeline, highlighting appointments, exercises and more.'
	      })
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      { pull: true, align: 'right' },
	      _react2.default.createElement(_Figure2.default, {
	        background: true,
	        sizes: props.data.screen2,
	        caption: 'Calendar items, allowing doctors to ask for tasks to be completed by the patient.'
	      })
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      null,
	      _react2.default.createElement(_Figure2.default, {
	        background: true,
	        sizes: props.data.screen3,
	        caption: 'A custom knowledge base for the patient.'
	      })
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      { align: 'right' },
	      _react2.default.createElement(_Figure2.default, {
	        background: true,
	        sizes: props.data.screen4,
	        caption: 'Chat with doctors, making it easy to request appointments or prescriptions.'
	      })
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      _Block2.default,
	      { full: true, pull: true, align: 'center' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Prototype'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'To showcase the screendesign and its animations, we created a prototype using After Effects.'
	      )
	    ),
	    _react2.default.createElement(
	      _Block2.default,
	      { align: 'center', pull: true },
	      _react2.default.createElement('video', { autoPlay: true, loop: true, src: _medical_companion_screenani2.default, playsInline: true, muted: true })
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/medical_companion_screenani.2def0894.mp4";

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Block = __webpack_require__(5);
	
	var _Block2 = _interopRequireDefault(_Block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bio = function (_React$Component) {
	  _inherits(Bio, _React$Component);
	
	  function Bio() {
	    _classCallCheck(this, Bio);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Bio.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'bio' },
	      _react2.default.createElement(
	        _Block2.default,
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Hello, I\'m Fabian \u2014 a product designer and developer based in Potsdam, Germany.'
	        )
	      ),
	      _react2.default.createElement(
	        _Block2.default,
	        { align: 'right' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'As a designer, I like to focus on projects in the travel and leisure industry. I work both as a product designer and a frontend developer. Take a look at my work here, or browse my side projects. Right now, I study Interface Design at the University of Applied Sciences in Potsdam and work as a freelancer.'
	        )
	      )
	    );
	  };
	
	  return Bio;
	}(_react2.default.Component);
	
	exports.default = Bio;
	module.exports = exports['default'];

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Post = __webpack_require__(57);
	
	var _Post2 = _interopRequireDefault(_Post);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var split = function split(items) {
	  var col1 = [];
	  var col2 = [];
	
	  items.map(function (item, i) {
	    if (i % 2 != 0) {
	      col1.push(item);
	    } else {
	      col2.push(item);
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'grid' },
	    _react2.default.createElement(
	      'div',
	      { className: 'col' },
	      col1
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col' },
	      col2
	    )
	  );
	};
	
	var preparePosts = function preparePosts(posts) {
	  var nodes = posts.map(function (post) {
	    if (post.node.path !== '/404/') {
	      return _react2.default.createElement(_Post2.default, { key: post.node.frontmatter.path, post: post });
	    }
	  });
	
	  return split(nodes);
	};
	
	exports.default = function (_ref) {
	  var posts = _ref.posts;
	  return _react2.default.createElement(
	    'div',
	    { id: 'work', className: 'posts' },
	    preparePosts(posts)
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(17);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Bio = __webpack_require__(55);
	
	var _Bio2 = _interopRequireDefault(_Bio);
	
	var _Posts = __webpack_require__(58);
	
	var _Posts2 = _interopRequireDefault(_Posts);
	
	var _SEO = __webpack_require__(37);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index() {
	    _classCallCheck(this, Index);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Index.prototype.render = function render() {
	    var _props = this.props,
	        transition = _props.transition,
	        data = _props.data;
	    var site = data.site,
	        allJavascriptFrontmatter = data.allJavascriptFrontmatter;
	
	    var articles = allJavascriptFrontmatter.edges;
	
	    return _react2.default.createElement(
	      'div',
	      { style: transition ? transition.style : { opacity: 0 } },
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: site.siteMetadata.title + ' | Designer and Frontend Developer'
	      }),
	      _react2.default.createElement(_SEO2.default, { postEdges: articles }),
	      _react2.default.createElement(
	        _Header2.default,
	        { cover: this.props.data.hero },
	        _react2.default.createElement(
	          'div',
	          { className: 'title' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Hello, I\u2019m Fabian \u2014 a designer and front-end developer based in Potsdam, Germany.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'summary' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'I\u2019m focused on turning ideas into delightful, practical software, doing my best work when collaborating closely with founders, designers, and developers.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Currently, I\u2019m studying Interface Design at the University of Applied Sciences in Potsdam, Germany.'
	          )
	        )
	      ),
	      _react2.default.createElement(_Posts2.default, { posts: articles })
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	Index.propTypes = {
	  route: _propTypes2.default.object
	};
	
	exports.default = Index;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-articles-dsk-companion-index-js-d58be1fd0e7ad8e8cda7.js